<ng-container *ngIf="newInvitationStore.state$ | async as state" [ngSwitch]="state.step">
  <vi-overlay-progress-bar *ngIf="state.creating"></vi-overlay-progress-bar>
  <app-new-invitation-form
    *ngSwitchCase="'InvitationForm'"
    [error]="state.error"
    (cancel)="onClose()"
    (newInvitation)="onNewInvitation($event)"
  ></app-new-invitation-form>
  <app-new-invitation-created
    *ngSwitchCase="'InvitationCreated'"
    (closed)="onClose()"
  ></app-new-invitation-created>
</ng-container>
